import { TransactionView } from "../../../models/view/transaction/transaction.view";
import { AccountView } from "../../../models/view/account/account.view";
import { TransactionOrigin } from "../../../models/types/transaction.types";
import { TransactionStatusEnum } from "../../../models/enum/transactionType";

export const getTransactionOrigin = (
  transaction: TransactionView,
  account: AccountView | undefined,
): TransactionOrigin => {
  if (transaction.origin) {
    return transaction.origin;
  }

  // The account can be missing (e.g. a search-opened transaction whose account was deleted).
  // Checked after transaction.origin so a transaction's own origin still renders in that case.
  if (!account) {
    return null;
  }

  if (
    transaction.accountLink.id !== account.id ||
    transaction.definition === TransactionStatusEnum.opening ||
    transaction.definition === TransactionStatusEnum.closing ||
    transaction.definition === TransactionStatusEnum.alignment
  ) {
    return null;
  }

  return account.origin;
};
